module.exports = __webpack_public_path__ + "img/banner-principal.75c1b8a4.png";